// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"solarpanel_220w_animationWrapper__degee"};